// extracted by css-extract-rspack-plugin
export default {"transactionAmount":"ueYG97"};